import { Bridge } from '@mc/mc-jsbridge'
import { printFinger } from '@mc/passport-h5'
import { eventbus } from '@/utils/eventbus'
import { EventNames } from '../../events'
import tracerVuePlugin from '@mc/tracer-vue-plugin'
export const getDeviceToken = () => {
  printFinger
    .getTokenByNative(Bridge)
    .then(data => {
      tracerVuePlugin.updateParam({
        tid: data.deviceToken || ''
      })
      eventbus.dispatch(EventNames.getDeviceToken, data.deviceToken)
    })
    .catch(e => {
      console.log(e)
    })
}
